const balados = [{
  "bande-annonce": {
    "id": 'teaser',
    "title": "1: Bande-annonce - Des histoires qui résonnent: le Balado des proches aidants",
    "description": "Ici Marina Orsini. J’ai le plaisir d’animer ce printemps l’émission “Des histoires qui résonnent : le Balado des proches aidants.”Saviez-vous qu’une personne sur quatre est proche aidante au Québec? Il s’agit peut-être de votre voisin, de votre mère, voire de vous.",
    "src": "/audios/episode1.wav",
    "image": "/images/vignette2.png",
    "srcVideo": "",
  },
  "episode-1": {
    "id": 1,
    "title": "Le lancement",
    "description": "Édith Fournier et Michel Carbonneau sont les auteurs de « Au-delà des mots : paroles de proches aidants ». Il s’agit d’un récit à deux voix : une femme et un homme qui racontent, en alternance, ce leur vécu auprès de leurs conjoints atteints de la maladie d’Alzheimer.",
    "src": "/audios/episode1.mp3",
    "image": "/images/vignette2.png",
    "srcVideo": "https://www.lappui.org/Autour-des-proches-aidants/Balado-Des-histoires-qui-resonnent/2021/Episode-1-Le-lancement"
  },
  "episode-2": {
    "id": 2,
    "title": "Devenir proche aidant",
    "description": "Comment se prépare-t-on à être proche aidant? Certains endossent ce rôle après des années de vie commune et d’autres, dès la naissance de leur enfant. Quand le diagnostic tombe, de nouvelles responsabilités tombent avec lui. Marina Orsini discute des premiers symptômes et de l’acceptation du rôle de proche aidant avec ses invités.",
    "src": "/audios/episode2.mp3",
    "image": "/images/vignette2.png",
    "srcVideo": "https://www.lappui.org/Autour-des-proches-aidants/Balado-Des-histoires-qui-resonnent/2021/Episode-2-Faire-face-aux-premiers-symptomes",
  },
  "episode-3": {
    "id": 3,
    "title": "La quête de services",
    "description": "Quoi faire lorsque les difficultés s’accumulent? Comment trouver le soutien nécessaire avant qu’il ne soit trop tard? La route vers l’obtention d’aide peut être sinueuse et provoquer une série d’émotions. Marina Orsini discute avec ses invités de l’aspect primordial de la quête de services.",
    "src": "/audios/episode3.mp3",
    "image": "/images/vignette2.png",
    "srcVideo": "https://www.lappui.org/Autour-des-proches-aidants/Balado-Des-histoires-qui-resonnent/2021/Episode-3-La-quete-de-services",
  },
  "episode-4": {
    "id": 4,
    "title": "Le quotidien à domicile",
    "description": "L'épuisement guette les personnes proches aidantes qui souvent pensent devoir tout donner au détriment de leur santé physique et mentale. Mais qu'arrive-t-il lorsque celles-ci prennent du temps pour elles, de temps à autre? Marina Orsini discute des bienfaits du répit et du lâcher-prise avec ses invités.",
    "src": "/audios/episode4.mp3",
    "image": "/images/vignette2.png",
    "srcVideo": "https://www.lappui.org/Autour-des-proches-aidants/Balado-Des-histoires-qui-resonnent/2021/Episode-4-Le-quotidien-a-domicile",
  },
  "episode-5": {
    "id": 5,
    "title": "La séparation",
    "description": "Plusieurs personnes proches aidantes devront y faire face : la séparation. Pour diverses raisons, envisager l’hébergement deviendra, malgré tout, une solution nécessaire. Marina Orsini discute de cette étape forte en émotions et ponctuée de petits deuils avec ses invités.",
    "src": "/audios/episode5.mp3",
    "image": "/images/vignette2.png",
    "srcVideo": "https://www.lappui.org/Autour-des-proches-aidants/Balado-Des-histoires-qui-resonnent/2021/Episode-5-La-separation",
  },
  "episode-6": {
    "id": 6,
    "title": "La vie en hébergement",
    "description": "Une fois le choc de l’hébergement passé, comment la personne proche aidante peut activer ses capacités d’adaptation ? Comment se transforme son rôle? Comment vit-on ses moments d’intimité avec son proche? Tant de questions sur lesquelles il faut se pencher. Marina Orsini discute de cette étape de résilience avec ses invités.",
    "src": "/audios/episode6.mp3",
    "image": "/images/vignette2.png",
    "srcVideo": "https://www.lappui.org/Autour-des-proches-aidants/Balado-Des-histoires-qui-resonnent/2021/Episode-6-La-vie-en-hebergement",
  },
  "episode-7": {
    "id": 7,
    "title": "Le deuil",
    "description": "Le deuil est une étape par laquelle plusieurs personnes aidantes devront passer. Qu’il soit blanc, pandémique ou inattendu, le deuil est une épreuve à traverser qui a son importance. Marina Orsini discute de cette étape souvent douloureuse avec ses invités.",
    "src": "/audios/episode7.mp3",
    "image": "/images/vignette2.png",
    "srcVideo": "https://www.lappui.org/Autour-des-proches-aidants/Balado-Des-histoires-qui-resonnent/2021/Episode-7-Le-deuil",
  },
  "episode-8": {
    "id": 8,
    "title": "La post-aidance",
    "description": "La post-aidance est la dernière étape dans la dyade aidant et aidé. Une fois que notre rôle prend fin, éprouvons-nous du soulagement ou un grand vide? Marina Orsini discute avec ses invités de l’étape significative de la post-aidance.",
    "src": "/audios/episode8.mp3",
    "image": "/images/vignette2.png",
    "srcVideo": "",
  },
}];

export default balados;